module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/canva/canva-step-03-58f78a9b7c9419f272654fd3df9c4cb0.jpg";